<template>
  <div class="pay-settings-tabs">
    <div class="flex items-center justify-between border-b border-flame">
      <div v-if="tabs.length > 0 && activeTab && activeTab !== tabs[0].id" class="w-7 flex items-center justify-center" @click="previousTab">
      <icon icon-name="chevronLeft" size="xs" class-name="cursor-pointer opacity-70 hover:opacity-100 "  />
      </div>
      <!-- Tabs Container -->
      <div ref="tabsContainer" class="flex-1 flex items-center gap-2 overflow-x-auto no-scrollbar relative" style="scrollbar-width: none;">
        <div class="flex items-center gap-2 bg-gray-100 flex-shrink-0 relative">
          <div
          v-for="(tab, index) in tabs"
          :key="index"
          :data-tab-id="tab.id"
          class="flex items-center gap-2 px-4 py-2 transition-all cursor-pointer"
          :class="{
            'bg-white text-flame': activeTab === tab.id,
            ' text-romanSilver ': activeTab !== tab.id
          }"
          @click="selectTab(tab.id)"
        >
          <span class="font-semibold capitalize text-lg">{{ tab.name }}</span>
          <div
          v-if="shouldShowEdit(tab)"
          @click.stop="editTab(tab)"

          >
            <Icon
            icon-name="edit"
            size="xs"
            class-name="cursor-pointer opacity-70 hover:opacity-100 text-flame"
          />
          </div>
          </div>

        </div>
      </div>
      <div v-if="tabs.length > 0 && activeTab && activeTab !== tabs[tabs.length - 1].id" class=" flex items-center justify-center" @click="nextTab">
      <icon icon-name="chevronRight" size="xs" class-name="cursor-pointer opacity-70 hover:opacity-100 ml-2"  />
      </div>
              <!-- Add New Tab Button -->
              <div
              v-if="!isBasic"
              class=" w-[max-content] flex items-center gap-1 px-3 py-2  cursor-pointer  text-mediumSeaGreen hover:bg-gray-200 transition-all"
              @click="addNewTab"
            >
            <div class="border-l border-cultured  h-5 w-2"></div>
              <icon icon-name="icon-plus-round" size="xs" class-name="!fill-white" style="fill: white;" />
              <span class="text-lg font-semibold capitalize" style="font-weight: 900;margin-top: 2px;">Add New</span>
            </div>

      <div v-if="!isScaleBased"
        class="flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer text-gray-600 hover:bg-gray-100 transition-all"
        @click="$router.push({ path: '/settings/payroll-settings', query: { payType: 'General' } })"
      >
      <div class="border-l border-cultured  h-5 w-2"></div>
        <Icon icon-name="settings" size="xs" class-name="text-flame text-bold" />
        <span class="text-lg font-bold text-flame">General Settings</span>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon";

export default {
  name: "PaySettingsTabs",
  components: {
    Icon
  },
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: [Number, String],
      default: null
    },
    isScaleBased:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    isBasic() {
      return this.$store.state.subscription && this.$store.state.subscription.plan === 'basic'
    }
  },
  methods: {
    shouldShowEdit(tab) {
      if (tab.name === 'Independent Contractor') {
        return false;
      }

      if (this.tabs.length === 1) {
        return false;
      }

      if (this.tabs.length === 2) {
        const otherTab = this.tabs.find(t => t.id !== tab.id);
        if (otherTab && otherTab.name === 'Independent Contractor') {
          return false;
        }
        return true;
      }
      return true;
    },
    selectTab(tabId) {
      this.$emit("tab-change", tabId);
    },
    editTab(tab) {
      this.$emit("edit-tab", tab);
    },
    addNewTab() {
      this.$emit("add-new-tab");
    },
    nextTab() {
      if (!this.activeTab || !this.tabs || this.tabs.length === 0) return;
      const currentIndex = this.tabs.findIndex(tab => String(tab.id) === String(this.activeTab));
      if (currentIndex !== -1 && currentIndex < this.tabs.length - 1) {
        const nextTab = this.tabs[currentIndex + 1];
        if (nextTab && nextTab.id) {
          this.$emit("next-tab", nextTab.id);
          this.scrollToActiveTab(nextTab.id);
        }
      }
    },
    previousTab() {
      if (!this.activeTab || !this.tabs || this.tabs.length === 0) return;
      const currentIndex = this.tabs.findIndex(tab => String(tab.id) === String(this.activeTab));
      if (currentIndex > 0) {
        const previousTab = this.tabs[currentIndex - 1];
        if (previousTab && previousTab.id) {
          this.$emit("previous-tab", previousTab.id);
          this.scrollToActiveTab(previousTab.id);
        }
      }
    },
    scrollToActiveTab(tabId) {
      this.$nextTick(() => {
        if (!this.$refs.tabsContainer) return;

        const container = this.$refs.tabsContainer;
        const tabElements = container.querySelectorAll('[data-tab-id]');
        let targetTab = null;

        tabElements.forEach(el => {
          if (String(el.getAttribute('data-tab-id')) === String(tabId)) {
            targetTab = el;
          }
        });

        if (targetTab) {
          const tabOffsetLeft = targetTab.offsetLeft;
          const tabWidth = targetTab.offsetWidth;
          const containerWidth = container.offsetWidth;
          const scrollPosition = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);

          container.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  },
  watch: {
    activeTab(newVal) {
      if (newVal) {
        this.scrollToActiveTab(newVal);
      }
    },
    $route: {
      handler(newRoute) {
        if (newRoute.query.payType === "independent-contractor" && this.tabs.length > 0) {
          const independentContractorTab = this.tabs.find(tab => tab.name === "Independent Contractor");
          if (independentContractorTab && this.activeTab !== independentContractorTab.id) {
            this.$nextTick(() => {
              this.selectTab(independentContractorTab.id);
            });
          }
        }
      },
      immediate: true
    },
    tabs: {
      handler(newTabs) {
        // When tabs are loaded, check if we need to select Independent Contractor
        if (newTabs.length > 0 && this.$route.query.payType === "independent-contractor") {
          const independentContractorTab = newTabs.find(tab => tab.name === "Independent Contractor");
          if (independentContractorTab && this.activeTab !== independentContractorTab.id) {
            this.$nextTick(() => {
              this.selectTab(independentContractorTab.id);
            });
          }
        }
      },
      immediate: true
    }
  },
};
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 2px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.pay-settings-tabs {
  min-width: 0;
}
</style>

